import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import InfoNav from './containers/InfoNav';
import InfoContent from './containers/InfoContent';
import SEOMeta from 'containers/SEOMeta';
import { selectors } from './ducks/page.duck';
import OnThisPage from 'components/general/OnThisPage/OnThisPage';

const getPageKey = createSelector(
  R.path(['screens', 'info', 'page', 'data', 'id']),
  R.path(['location', 'payload', 'path']),
  (id, path) => id || path || '',
);

const InfoPage = ({ pageKey }) => (
  <div className="l-sub-page l-sub-page--info">
    <SEOMeta selector={selectors.data} />
    <div className="l-sub-page__aside">
      <div className="l-sub-page__nav">
        <InfoNav />
      </div>
    </div>
    <div className="l-sub-page__main">
      <div className="l-static-page" key={pageKey}>
        <InfoContent />
      </div>
    </div>
    <div className="l-sub-page__on-this-page" key={pageKey}>
      <OnThisPage />
    </div>
  </div>
);

export default connect(state => ({
  pageKey: getPageKey(state),
}))(InfoPage);
